import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaRegEnvelope, FaUserAlt } from "react-icons/fa";

import { socialNetwork } from "../../data";
import LanguageWidget from "./sub-components/LanguageWidget";

const MobileWidgets = () => {
  return (
    <div className="offcanvasWidgetArea">
      <div className="offCanvasContactWidget">
        <div className="headerContactInfo">
          <ul className="headerContactInfoList">
            <li>
            <LanguageWidget/>
            </li>
            <br/>
            <li>
              <FaUserAlt />{" "}
              <Link to={process.env.PUBLIC_URL + "/login-register"}>
                Login / Register{" "}
              </Link>
            </li>
            <li>
              <FaPhone /> <a href="tel://12452456012">(1245) 2456 012 </a>
            </li>
            <li>
              <FaRegEnvelope />{" "}
              <a href="mailto:info@yourdomain.com">info@yourdomain.com</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="offCanvasWidgetSocial">
        {socialNetwork.map((val, index) => {
          return (
            <a
              key={index}
              href={val.url}
              target="_blank"
              rel="noopener noreferrer"
              title={val.title}
            >
              {val.icon}
            </a>
          );
        })}
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
